import {
  TeaserEntry,
  AudioTeaserEntry,
} from "../helper/interfaces";
import React, { useContext } from "react";

import { ContentType } from "../helper/enums";
import { getAuthorNames } from "../helper/author";
import { AppContext } from "../provider/AppContextProvider";
import { getTeaserImageUrl, getTeaserTypeIcons } from "../helper/images";
import CustomImage from "./ui/Image";
import TeaserInfos from "./TeaserInfos";
import parse from "html-react-parser";

export interface TeaserData {
  teaser: TeaserEntry;
  ignoreLead?: boolean;
}

function TeaserBaseNB(data: TeaserData) {
  const { audioPlayer } = useContext(AppContext);

  const teaser = data.teaser;
  const image = teaser?.images ? teaser.images[0] : undefined;
  const imageUrl = image && getTeaserImageUrl(image);

  const iconsNB = getTeaserTypeIcons(teaser.teaserTypes);

  const authorNames = getAuthorNames(teaser.authors);

  return (
    <>
      {imageUrl && (
        <div className="teaser-image">
          <CustomImage
            src={imageUrl}
            fill
            className="object-cover"
            alt={image.title}
          />

          {teaser.date && <div></div>}

          {teaser.modulePatch && (
            <div className="teaser-module-patch">{teaser.modulePatch}</div>
          )}
          {iconsNB.length > 0 && (
              <div className="teaser__image__icons">
                {iconsNB.map((icon, i) => (
                  <div
                    key={`icon-${i}`}
                    className={`teaser__image__icon ${icon}`}
                  ></div>
                ))}
              </div>
            )}
        </div>
      )}

      <div className="teaser-body">
        {teaser.type === ContentType.Podcast && (
          <div className="teaser-podcast-play">
            {audioPlayer?.playing &&
            audioPlayer.audioUrl === (teaser as AudioTeaserEntry).audioUrl ? (
              <div className="icon-button_pause"></div>
            ) : (
              <div className="icon-button_play"></div>
            )}
          </div>
        )}

        <TeaserInfos teaser={teaser} />

        {teaser.title && (
          <h3 className="teaser-title">{teaser.title}</h3>
        )}

        {data.ignoreLead != true && teaser.lead && (
          <p className="teaser-lead">{parse(teaser.lead)}</p>
        )}

        {authorNames && (
          <div className="teaser-meta">
            <span className="teaser-author">
              {authorNames && `Von ${authorNames}`}
            </span>
          </div>
        )}
      </div>
    </>
  );
}

export default TeaserBaseNB;
